import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  Router,
  RouterStateSnapshot,
  UrlTree,
} from '@angular/router';
import { Observable } from 'rxjs';
import { AuthService } from '../services/auth.service';

// Dieser Code definiert einen Angular Guard namens LoggedInGuard, um den Zugriff auf bestimmte Routen in der Angular Anwendung zu steuern.
//
// Die canActivate Methode ist die Hauptmethode der Guard-Klasse und wird jedes Mal aufgerufen, wenn eine Route
// aktiviert wird. Diese Methode erhält zwei Parameter, route und state, die Informationen über die aktuelle Route
// und den Zustand der Anwendung enthalten.
//
// In der canActivate Methode wird zunächst geprüft, ob der Benutzer authentifiziert ist, indem die isAuthenticated$
// Eigenschaft des AuthService aufgerufen wird. Wenn der Benutzer authentifiziert ist, gibt die Methode true zurück
// und die Navigation wird fortgesetzt.
//
// Zusammenfassend kann man sagen, dass dieser Code eine Guard-Klasse definiert, die den Zugriff auf bestimmte Routen
// in der Angular Anwendung regelt und sicherstellt, dass der Benutzer authentifiziert ist, bevor er auf bestimmte
// Funktionen zugreifen kann.

@Injectable({
  providedIn: 'root',
})
export class LoggedInGuard implements CanActivate {
  constructor(private auth: AuthService, private router: Router) {}

  async canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Promise<boolean | UrlTree> {
    const isLoggedIn = await this.auth.isAuthenticated$.getValue();
    if (isLoggedIn) {
      return true;
    }

    localStorage.setItem('attemptedRoute', state.url);
    return this.router.parseUrl('/');
  }
}
